import { setDoc } from "firebase/firestore";

import { appFaultModel } from "@/core/modules/appFault/models/AppFaultModel";
import { Notification } from "@/core/modules/notification/objects/Notification";
import { notificationModel } from "../NotificationModel";
import { store } from "@/core/modules/store/module";
import { storeTypes } from "@/core/modules/store/types";
import { User } from "@/core/modules/user/objects/User";

export const markNotificationAsRead = async (notificationId: string): Promise<void> => {
  try {
    const notification: Notification = await notificationModel.getDocument(notificationId);

    const user: User = store.getters[storeTypes.getters.getUser];

    const unreadIndex = notification.unread.indexOf(user.id);
    if (unreadIndex < 0) {
      throw new Error(`User #${user.id} not found in notification #${notificationId}`);
    }
    notification.unread.splice(unreadIndex, 1);

    // check if user can update the document
    if (notification.owners.includes(user.id) === false) {
      throw new Error(`Unable to update document #${notification.id} in collection ${notificationModel.collectionName}`);
    }

    await setDoc(notificationModel.getDocumentReference(notification.id).withConverter(notificationModel.firestoreConverter), notification);
  } catch (error: unknown) {
    appFaultModel.catchAppError("NotificationModel.markNotificationAsRead", { notificationId }, error);
  }
};
